const meta = {
  'differential-diagnosis': 'Identify trends',
  'telemetry-analyzer': 'Analyze metrics',
  'trace-analyzer': 'Analyze traces',
  usage: 'Analyze usage',
  'query-analyzer': 'Analyze queries',
};

export default meta;
